<template>
  <div class="goods">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:gap-2">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <LinkButton buttonText="Tambah Kategori Barang" url="/goods-category/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end mdmax:flex-auto mdmax:w-full">
        <div class="w-3/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" v-model="searchTerm" :withIcon="true" placeholder="Cari nama kategori barang" @enter="doSearch()" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/goods-category/detail/${entry.code}`" linkType="internal" type="secondary" size="small" />
        <span v-else-if="column.field === 'sub_category_code'">{{ entry[column.field] ? 'Ya' : 'Tidak' }}</span>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data() {
    return {
      columns: [
        // { label: 'ID', field: 'code' },
        { label: 'Nama Kategori', field: 'name' },
        { label: 'Deskripsi', field: 'category_description' },
        { label: 'Sub Kategori', field: 'sub_category_code' },
        { label: 'Nama Sub Kategori', field: 'sub_category_name' },
        { label: 'Action', field: 'action' }
      ],
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  computed: {
    ...mapGetters('master', ['goodsCategories']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    filteredData() {
      let temp = this.goodsCategories || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/goods-category', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getGoodsCategoryList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getGoodsCategoryList()
      } else {
        this.$router.push({ path: '/goods-category', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('master', ['getGoodsCategories']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getGoodsCategoryList(searchTerm = '') {
      this.showLoading()
      this.getGoodsCategories({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    doSearch() {
      this.getGoodsCategoryList(this.searchTerm)
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/goods-category', query: { page: page } })
    }
  }
}
</script>
